import { useMemo } from 'react';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import { useTranslate } from '@jd/i18n';
import { generateStepValidationSchema } from '../formBuilder';
import { FormField } from '../../type';

type Args = {
  fields: FormField[];
  currentStep: number;
};

const useStepValidation = ({ fields, currentStep }: Args) => {
  const common_t = useTranslate('common');
  return useMemo(
    () =>
      toFormikValidationSchema(
        generateStepValidationSchema(fields, currentStep, common_t),
      ),
    [fields, currentStep, common_t],
  );
};

export default useStepValidation;
